import React, { ReactElement } from 'react'
import { IconWrapper, Icon, Image } from './subcomponents'
import { Small, H3 } from '../../typography'

interface IconButtonProps {
  src: string
  title?: string
  isAnimationAllowed?: boolean
  onSubmit?: () => void
  isBold?: boolean
}

const IconButton = ({
  src,
  isAnimationAllowed = false,
  onSubmit,
  title,
  isBold
}: IconButtonProps): ReactElement => {
  return (
    <IconWrapper>
      <Icon
        variant="outline-primary"
        $isAnimationAllowed={isAnimationAllowed}
        onClick={onSubmit}
      >
        <Image src={src} />
      </Icon>
      {title && (isBold ? <H3>{title}</H3> : <Small>{title}</Small>)}
    </IconWrapper>
  )
}

export default IconButton
